import React from "react";
import { Helmet } from "react-helmet-async";
import { getAlternateLanguageLinks, getCanonicalUrl } from "./seoRoutes";

const SeoHead = ({
  title,
  description,
  pathname,
  image,
  type = "website",
  jsonLd = [],
  noIndex = false,
}) => {
  const canonicalUrl = getCanonicalUrl(pathname || window.location.pathname);
  const alternateLinks = getAlternateLanguageLinks(pathname || window.location.pathname);

  return (
    <Helmet prioritizeSeoTags>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={noIndex ? "noindex,nofollow" : "index,follow"} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content={type} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={canonicalUrl} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:url" content={canonicalUrl} />
      {image ? <meta name="twitter:image" content={image} /> : null}
      {alternateLinks.map((link) => (
        <link key={`${link.hrefLang}:${link.href}`} rel="alternate" hrefLang={link.hrefLang} href={link.href} />
      ))}
      {jsonLd.map((entry, index) => (
        <script key={entry?.["@type"] || index} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
